var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PrimeVueButton',{style:(_vm.styles),attrs:{"label":_vm.label,"icon":_vm.icon,"icon-pos":_vm.iconPos},on:{"click":function($event){return _vm.$emit('click', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }